import React, { useEffect } from 'react';
import Link from 'next/link';
import { CardSection } from '../../ArticlePage/RelatedArticlesNew/styled';
import {
  ArticleHeading,
  ArticleList,
} from '../../ArticlePage/InthisArticle/styled';
import { RoundListCircle } from './styled';
import { headerFooterData } from '../../../Constants/HomePage';
import { removeDefaultParams } from '../../../Utils/helper';
import { useRouter } from 'next/router';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function DiscoverTopics() {
  const router = useRouter();
  useEffect(() => {
    if (headerFooterData?.length) fireServedSectionEvent('Discover Topics In');
  }, []);
  return (
    <CardSection>
      <ArticleHeading>
        <RoundListCircle></RoundListCircle> Discover Topics In
      </ArticleHeading>
      <ArticleList>
        {headerFooterData?.map((element, index) => {
          if (element.type != 2 && element.title != 'Get Mylo App') {
            return (
              <Link
                href={{
                  pathname: element?.deepLink,
                  query: removeDefaultParams(router.query),
                }}
                passHref
                key={`subcatfooter${index}`}
                locale={false}
              >
                <li
                  onClick={() =>
                    fireClickedCardEvent(
                      'Discover Topics In',
                      element?.title,
                      'topic',
                    )
                  }
                  key={`header_${index}`}
                >
                  <RoundListCircle></RoundListCircle> {element?.title}
                </li>
              </Link>
            );
          }
        })}
      </ArticleList>
    </CardSection>
  );
}
